import { memo } from 'react'

const parallaxStyle = (speed: number) => ({
  transform: `translateY(calc(var(--scroll-y, 0) * ${speed} * 1px)) translateX(calc(var(--mouse-x, 0) * 0.5px))`,
})

const ORB_1_STYLE = parallaxStyle(0.1)
const ORB_2_STYLE = parallaxStyle(-0.15)
const ORB_3_STYLE = parallaxStyle(0.08)
const GRID_STYLE = parallaxStyle(-0.05)

export const BackgroundOrbs = memo(function BackgroundOrbs() {
  return (
    <>
{/* Image Background */}
<div className="video-background">
  <img
    src="https://firebasestorage.googleapis.com/v0/b/liam-portfolio.appspot.com/o/Fotolia_241479172_XL.jpg?alt=media&token=ea5fa472-6430-4922-b7d6-69baac3527a6"
    alt="Background"
    className="background-video"
  />
  <div className="video-overlay"></div>
</div>

{/* Floating Background Elements */}
<div className="floating-background">
  <div className="bg-orb orb-1" style={ORB_1_STYLE}></div>
  <div className="bg-orb orb-2" style={ORB_2_STYLE}></div>
  <div className="bg-orb orb-3" style={ORB_3_STYLE}></div>
  <div className="bg-grid" style={GRID_STYLE}></div>
</div>
    </>
  )
})
